export const log = console.log

export const warning = console.warn
export const error = console.error

export const extend = Object.assign

export const isArray = Array.isArray

export const objectToString = Object.prototype.toString

export const toTypeString = (value: unknown): string => objectToString.call(value)

export const isMap = (val: unknown): val is Map<any, any> => toTypeString(val) === '[object Map]'

export const isSet = (val: unknown): val is Set<any> => toTypeString(val) === '[object Set]'

export const isDate = (val: unknown): val is Date => val instanceof Date

export const isFunction = (val: unknown) => typeof val === 'function'

export const isString = (val: unknown): val is string => typeof val === 'string'

export const isNumber = (val: unknown): val is number => typeof val === 'number'

export const isSymbol = (val: unknown): val is symbol => typeof val === 'symbol'

export const isObject = (val: unknown): val is Record<any, any> => val !== null && typeof val === 'object'

export const isPromise = <T = any>(val: unknown): val is Promise<T> => {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch)
}

export const newError = (msg: string) => {
  throw new Error(msg)
}

export const isJSON = (val: unknown) => {
  try {
    return isString(val) && isObject(JSON.parse(val))
  } catch (error) {
    return false
  }
}

export const toNumber = (val: unknown): number => {
  if (isNumber(val)) return val
  if (isString(val)) {
    const n = parseFloat(val)
    return Number.isNaN(n) ? 0 : n
  } else {
    return 0
  }
}

// 生成随机字符串
export function randomString(len: number) {
  const len_ = len || 32
  const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const a = t.length
  let n = ''
  for (let i = 0; i < len_; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

export function createUid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function toVw(px: number) {
  return px * (100 / 750)
}

// 数字每三位加逗号
export function formatNumber(num: number) {
  return num.toString().replace(/\d+/, function(n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  })
}

export function calcNum(num: number | null | undefined) {
  if (num === null || num === undefined) return '0'
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2) + 'M'
  } else if (num > 1000) {
    return (num / 1000).toFixed(2) + 'K'
  } else {
    return num.toString()
  }
}
